export default __webpack_public_path__ + "static/media/product40.e68acd44.png";